import {createReducer} from "redux-act";
import {showPromptModal, closePromptModal} from "modules/actions/prompt_modal";

interface IPromptStore {
	modal: ReturnType<typeof showPromptModal>["payload"] | null;
}

const defaultState: IPromptStore = {
	modal: null,
};

export const promptStore = createReducer({}, defaultState)
	.on(showPromptModal, (state, payload) => ({
		...state,
		modal: payload,
	}))
	.on(closePromptModal, (state) => ({
		...state,
		modal: null,
	}));
